import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import { BackButton } from '../components/BackButton';
import { EmptyState, ErrorMessage, LoadingGrid } from '../components/LoadingGrid';
import { api } from '../lib/api-client';
import { useCurrentUser } from '../lib/hooks';

/**
 * Riwayat tonton. ID Telegram terdeteksi otomatis dari initData. Tiap
 * baris lanjut ke episode yang terakhir ditonton (resume).
 */
export function HistoryPage() {
  const meQuery = useCurrentUser();
  const me = meQuery.data?.user ?? null;

  const histQuery = useQuery({
    queryKey: ['history'],
    queryFn: () => api.history(),
    enabled: me !== null,
  });

  return (
    <div className="mx-auto max-w-3xl px-4 pb-8 safe-top">
      <header className="flex items-center gap-1 py-2">
        <BackButton className="-ml-2" />
        <h1 className="font-display text-xl font-bold">Riwayat</h1>
      </header>

      {me === null ? (
        <EmptyState message="Buka aplikasi lewat Telegram (@DongNime_Bot) untuk menyimpan riwayat tonton." />
      ) : histQuery.isPending ? (
        <LoadingGrid />
      ) : histQuery.isError ? (
        <ErrorMessage
          title="Gagal memuat riwayat"
          message={histQuery.error.message}
          onRetry={() => void histQuery.refetch()}
        />
      ) : histQuery.data.items.length === 0 ? (
        <EmptyState message="Belum ada riwayat tonton." />
      ) : (
        <div className="space-y-2">
          {histQuery.data.items.map((h) => {
            const pct =
              h.durationSeconds && h.durationSeconds > 0
                ? Math.min(100, Math.round((h.positionSeconds / h.durationSeconds) * 100))
                : 0;
            return (
              <Link
                key={h.id}
                to={`/player/${h.platform}/${h.externalDramaId}/${h.externalEpisodeId}`}
                className="flex gap-3 rounded-lg border border-neutral-800 bg-neutral-900 p-2 hover:border-neutral-600"
              >
                <div className="relative h-16 w-12 shrink-0 overflow-hidden rounded bg-neutral-800">
                  {h.dramaPoster && (
                    <img
                      src={h.dramaPoster}
                      alt=""
                      className="h-full w-full object-cover"
                      onError={(e) => {
                        (e.currentTarget as HTMLImageElement).style.display = 'none';
                      }}
                    />
                  )}
                </div>
                <div className="flex min-w-0 flex-1 flex-col justify-center">
                  <h3 className="line-clamp-1 text-sm font-medium">{h.dramaTitle}</h3>
                  <p className="mt-0.5 text-xs text-neutral-400">
                    Ep {h.episodeNumber}
                    {h.completed ? ' · selesai' : pct > 0 ? ` · ${pct}%` : ''}
                    <span className="ml-1 uppercase text-neutral-600">{h.platform}</span>
                  </p>
                  {pct > 0 && !h.completed && (
                    <div className="mt-1.5 h-1 w-full overflow-hidden rounded-full bg-neutral-800">
                      <div className="h-full bg-brand-500" style={{ width: `${pct}%` }} />
                    </div>
                  )}
                </div>
              </Link>
            );
          })}
        </div>
      )}
    </div>
  );
}
